<div class="so" [class.visible]="soActive">
  <div class="so__close" [class.visible]="soActive">
    <svg viewBox="0 0 24 24" width="24px" height="24px" (click)="onClose()">
      <use xlink:href="assets/icons/close_right.svg#svg1"></use>
    </svg>
  </div>
  <ng-content select="app-so-content"></ng-content>
</div>

